const EMAIL_REGEX = '^\\w+([\\.-]?\\w+)*@\\w+([\\.-]?\\w+)*(\\.\\w{2,3})+$';

const EMAIL = new RegExp(`^${EMAIL_REGEX}$`);

export {
  EMAIL
};
